<div class="dvs-chart">
	@if (options) {
		<highcharts-chart [style.height]="height" [options]="options" (chartInstance)="onLoad($event)" [style.opacity]="chartLoaded ? 1 : 0"></highcharts-chart>
	}
	@if (!chartLoaded) {
		<div [style.height]="height" class="chartloading" [class.overlay]="options">
			@if (!error) {
				<div class="indicator" [ngClass]="{ short }">
					<div class="logo-spin"></div>
					@if (!short) {
						<span>{{loading}}</span>
					}
				</div>
			}
			@if (error) {
				<div class="indicator" [ngClass]="{ short }">
					<div class="logo-spin stopped"></div>
					{{error}}
				</div>
			}
		</div>
	}
</div>